
import { Search } from "lucide-react";
import { motion } from "framer-motion";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface SearchInputProps {
  query: string;
  onQueryChange: (query: string) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  isAISearch?: boolean;
}

const SearchInput = ({ 
  query, 
  onQueryChange, 
  onSubmit, 
  isAISearch = false 
}: SearchInputProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className={`relative w-full max-w-2xl mx-auto ${isAISearch ? 'bg-white/5' : 'bg-white/10'} backdrop-blur-md rounded-full overflow-hidden group transition-all duration-300 hover:bg-white/15 hover:shadow-[0_0_30px_rgba(214,188,250,0.3)]`}>
        <Input
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder={isAISearch ? "Ask our AI about business growth and sales strategies..." : "Ask us anything about sales and business solutions..."}
          className="pl-12 pr-32 py-6 w-full border-none text-lg bg-transparent text-white placeholder:text-white/60"
        />
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60 w-5 h-5" />
        <div className="absolute right-2 top-1/2 -translate-y-1/2">
          <Button 
            type="submit"
            className={`rounded-full ${isAISearch ? 'bg-purple-500 hover:bg-purple-600' : 'bg-white hover:bg-white/90'} ${isAISearch ? 'text-white' : 'text-black'} transition-all duration-300`}
          >
            {isAISearch ? "Ask AI" : "Ask Now"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default SearchInput;
